module.exports = __webpack_public_path__ + "static/media/mainChart1ForError3.483264ad.png";